export default {
    methods: {
        loginOut () {
            window.localStorage.clear()
            // 跳转到首页
            //   router.push('/')
            window.location.reload()
            //  return  window.location.href = "./login";
        }
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/mixin/index.js
// module id = null
// module chunks = 